import { request } from "./client";
import type { Campaign, CampaignAssignmentCommand, CampaignCreateCommand, CampaignStatus } from "./types";

const base = "/admin/v1/campaigns";

export const campaigns = {
  list: () => request<Campaign[]>(base),
  get: (id: string) => request<Campaign>(`${base}/${id}`),
  create: (command: CampaignCreateCommand) => request<Campaign>(base, { method: "POST", body: command, csrf: true }),
  transition: (id: string, entityVersion: number, status: CampaignStatus, reason: string) =>
    request<Campaign>(`${base}/${id}/transition`, { method: "PUT", body: { entityVersion, status, reason }, csrf: true }),
  assign: (id: string, command: CampaignAssignmentCommand) =>
    request<Campaign>(`${base}/${id}/assignments`, { method: "PUT", body: command, csrf: true }),
  removeAssignment: (id: string, placementId: string, entityVersion: number) =>
    request<Campaign>(`${base}/${id}/assignments/${placementId}`, {
      method: "DELETE",
      csrf: true,
      headers: { "If-Match-Version": String(entityVersion) },
    }),
};
